import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { Plus, Trash, PencilSimple, Check, X } from "@phosphor-icons/react";

export default function CategoriesPanel() {
  const [cats, setCats] = useState([]);
  const [name, setName] = useState("");
  const [editId, setEditId] = useState(null);
  const [editName, setEditName] = useState("");

  const load = () => api.get("/categories").then(({ data }) => setCats(data));
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!name.trim()) return;
    try {
      await api.post("/admin/categories", { name, order: cats.length });
      setName("");
      toast.success("Category added");
      load();
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    }
  };

  const saveEdit = async (id) => {
    await api.put(`/admin/categories/${id}`, { name: editName, order: 0 });
    setEditId(null);
    toast.success("Updated");
    load();
  };

  const remove = async (id) => {
    if (!window.confirm("Delete this category?")) return;
    await api.delete(`/admin/categories/${id}`);
    toast.success("Deleted");
    load();
  };

  return (
    <div className="max-w-2xl">
      <h2 className="font-serif text-3xl font-light">Categories</h2>
      <p className="text-sm text-muted-foreground mt-1">Used to filter projects on the site.</p>

      <div className="mt-8 flex gap-3">
        <input
          data-testid="category-name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && add()}
          placeholder="New category name"
          className="flex-1 bg-transparent border border-border px-4 py-3 text-sm focus:outline-none focus:border-foreground"
        />
        <button data-testid="add-category" onClick={add} className="inline-flex items-center gap-2 bg-foreground text-background text-xs uppercase tracking-[0.15em] px-5 hover:bg-accent transition-colors">
          <Plus size={16} /> Add
        </button>
      </div>

      <div className="mt-8 divide-y divide-border border border-border">
        {cats.map((c) => (
          <div key={c.id} className="flex items-center justify-between px-4 py-4" data-testid={`category-${c.slug}`}>
            {editId === c.id ? (
              <input value={editName} onChange={(e) => setEditName(e.target.value)} className="flex-1 bg-transparent border-b border-foreground text-sm mr-4 focus:outline-none" />
            ) : (
              <div>
                <p className="font-medium">{c.name}</p>
                <p className="text-xs text-muted-foreground">/{c.slug}</p>
              </div>
            )}
            <div className="flex gap-3">
              {editId === c.id ? (
                <button onClick={() => saveEdit(c.id)} className="text-accent"><Check size={18} /></button>
              ) : (
                <button onClick={() => { setEditId(c.id); setEditName(c.name); }} className="text-foreground/60 hover:text-foreground"><PencilSimple size={16} /></button>
              )}
              {editId === c.id ? (
                <button onClick={() => setEditId(null)}><X size={18} /></button>
              ) : (
                <button onClick={() => remove(c.id)} className="text-destructive"><Trash size={16} /></button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
